module.exports = __webpack_public_path__ + "static/media/pythoncode.79a349ed.jpg";